import hlb_brand from "../../../content/dam/hlb/my/chatbot/images/hlb-brand.png";

export default function HLBLogo() {
    return (
        <img src={ hlb_brand } alt="Hong Leong Bank"/>
    );
};
